import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinCareAndDiet = lazyWithPreload(
  () => import('./SkinCareAndDiet'),
)
